<div class="position-relative">
  <div class="position-relative">
    <picture>
      <img class="banner-img object-fit-cover" [src]="img" width="100%" alt="Elsa">
    </picture>
    <div class="banner-gradient">
      <div class="container">
        <div class="row">
          <div class="col-60 pl-4 ">
            <div class="border-title"></div>
            <h1 class="text-white text-uppercase banner-title elsa-title-font">{{title}}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="hasBorder" class="bg-{{backgroundColorBorder}}">
    <div class="container-fluid p-0 m-0">
      <div class="row p-0 m-0">
        <div class="col-60 p-0 m-0 position-relative" [ngClass]="{'border-spacer':hasBorderSpacer}">
          <div class="d-flex flex-row justify-content-center w-100 border-absolute" >
            <div class="w-100 container-fluid-960 banner-border"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
